document.addEventListener('DOMContentLoaded', () => {
  const generatePdfButton = document.querySelector('#generate-pdf-link');
  const pdfProcessingModal = document.querySelector('#pdfProcessingModal');
  const acceptModalButton = document.querySelector('#acceptModal');
  
  const logInfo = (message, data = null) => {
    console.log(`[PDF Generator] ${message}`, data || '');
    // Füge hier eine Funktion hinzu, um Logs an den Server zu senden
    sendLogToServer(message, data);
  };

  // Funktion zum Senden von Logs an den Server
  async function sendLogToServer(message, data = null) {
    try {
      const formData = new FormData();
      formData.append('logType', 'frontend');
      formData.append('message', message);
      formData.append('data', JSON.stringify(data));
      formData.append('userAgent', navigator.userAgent);
      formData.append('timestamp', new Date().toISOString());
      
      await fetch('https://baurelia.mainwebsite.ch/uploadpdf/log-events.php', {
        method: 'POST',
        body: formData
      });
    } catch (error) {
      console.error('Fehler beim Senden des Logs:', error);
    }
  }

  // Create an overlay for blocking user interactions
  const overlay = document.createElement('div');
  overlay.id = 'interaction-blocker';
  overlay.style.position = 'fixed';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100%';
  overlay.style.height = '100%';
  overlay.style.backgroundColor = 'rgba(0, 0, 0, 0)';
  overlay.style.zIndex = '99999';
  overlay.style.display = 'none';
  document.body.appendChild(overlay);

  // Check interactions on specific elements
  const interactiveElements = ['.text-styling__personalizer-item', '.mw-r_button', '.mw-wunschtext-field', '.color-picker__item', '.image-swatch'];

  logInfo('PDF Generator initialisiert');

  interactiveElements.forEach((selector) => {
    document.querySelectorAll(selector).forEach((element) => {
      element.addEventListener('click', () => {
        logInfo(`Element geklickt: ${selector}`);
        enableGeneratePdfButton();
      });
    });

    // Observe dynamically added elements
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.matches && node.matches(selector)) {
              node.addEventListener('click', () => {
                logInfo(`Dynamisch hinzugefügtes Element geklickt: ${selector}`);
                enableGeneratePdfButton();
              });
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });

  function enableGeneratePdfButton() {
    if (generatePdfButton) {
      generatePdfButton.disabled = false;
      generatePdfButton.style.pointerEvents = 'auto';
      generatePdfButton.style.backgroundColor = '';
      generatePdfButton.style.color = '';
      generatePdfButton.style.cursor = 'pointer';
      logInfo('PDF-Button aktiviert');
    } else {
      logInfo('PDF-Button nicht gefunden bei Aktivierungsversuch');
    }
  }

  // Function to show confirmation modal
  function showConfirmationModal() {
    if (pdfProcessingModal) {
      pdfProcessingModal.classList.add('open');
      document.body.classList.add('overflow-hidden');
      logInfo('Bestätigungsmodal geöffnet und Body-Scroll deaktiviert');
    } else {
      logInfo('Bestätigungsmodal nicht gefunden');
    }
  }

  // Function to hide confirmation modal
  function hideConfirmationModal() {
    if (pdfProcessingModal) {
      pdfProcessingModal.classList.remove('open');
      document.body.classList.remove('overflow-hidden');
      logInfo('Bestätigungsmodal geschlossen und Body-Scroll aktiviert');
    }
  }

  // Function to ensure all images are loaded
  function ensureImagesLoaded(node) {
    const images = node.querySelectorAll('img');
    logInfo(`Warte auf ${images.length} Bilder zum Laden`);
    
    const promises = Array.from(images).map((img, index) => {
      if (img.complete) {
        logInfo(`Bild ${index + 1}/${images.length} bereits geladen`);
        return Promise.resolve();
      }
      return new Promise(resolve => {
        img.onload = () => {
          logInfo(`Bild ${index + 1}/${images.length} erfolgreich geladen`);
          resolve();
        };
        img.onerror = () => {
          logInfo(`Fehler beim Laden von Bild ${index + 1}/${images.length}`, {
            src: img.src,
            width: img.width,
            height: img.height
          });
          resolve(); // Proceed even on error
        };
      });
    });
    return Promise.all(promises);
  }

  // Main PDF generation function
  async function generatePdf() {
    logInfo("PDF-Generierung nach Bestätigung gestartet");
    
    // Show spinner and disable the button
    const spinner = document.createElement('span');
    spinner.className = 'spinner';
    generatePdfButton.appendChild(spinner);
    generatePdfButton.disabled = true;
    generatePdfButton.style.cursor = 'not-allowed';
    generatePdfButton.style.pointerEvents = 'none';
    overlay.style.display = 'block';

    const node = document.querySelector('#print_pdf');

    if (node) {
      logInfo("Element #print_pdf gefunden", {
        width: node.clientWidth,
        height: node.clientHeight
      });
      
      const randomId = generateRandomId(16);
      const scale = 9;
      const width = node.clientWidth * scale;
      const height = node.clientHeight * scale;

      logInfo("PDF-Generierung gestartet", {
        randomId,
        scale,
        width,
        height
      });

      try {
        // Wait for all images to load
        await ensureImagesLoaded(node);
        logInfo("Alle Bilder geladen");

        // Store original states to restore later
        const originalStyles = [];
        const images = node.querySelectorAll('img');
        logInfo(`Anzahl der Bilder: ${images.length}`);
        
        // Fix all images in place
        images.forEach((img, index) => {
          const computedStyle = window.getComputedStyle(img);
          const rect = img.getBoundingClientRect();
          
          // Store original styles
          originalStyles.push({
            element: img,
            position: img.style.position,
            left: img.style.left,
            top: img.style.top,
            width: img.style.width,
            height: img.style.height,
            transform: img.style.transform,
            margin: img.style.margin,
            zIndex: img.style.zIndex
          });
          
          // Force position to be exactly where it is now
          img.style.position = 'fixed';
          img.style.left = `${rect.left}px`;
          img.style.top = `${rect.top}px`;
          img.style.width = `${rect.width}px`;
          img.style.height = `${rect.height}px`;
          img.style.transform = 'none';
          img.style.margin = '0';
          img.style.zIndex = computedStyle.zIndex;
          
          logInfo(`Bild ${index + 1} Position fixiert`, {
            left: rect.left,
            top: rect.top,
            width: rect.width,
            height: rect.height
          });
        });
        
        // Hide overlay during image generation
        overlay.style.display = 'none';
        
        // Force a layout calculation
        node.offsetHeight;
        
        logInfo("Starte domtoimage.toPng Konvertierung");
        const domToImageStart = performance.now();
        const dataUrl = await domtoimage.toPng(node, {
          width,
          height,
          quality: 1,
          style: {
            transform: `scale(${scale})`,
            transformOrigin: 'top left',
            'font-smoothing': 'antialiased'
          }
        });
        const domToImageEnd = performance.now();
        logInfo(`domtoimage.toPng abgeschlossen in ${(domToImageEnd - domToImageStart).toFixed(2)}ms`);
        
        // Restore original styles for all elements
        originalStyles.forEach(item => {
          item.element.style.position = item.position;
          item.element.style.left = item.left;
          item.element.style.top = item.top;
          item.element.style.width = item.width;
          item.element.style.height = item.height;
          item.element.style.transform = item.transform;
          item.element.style.margin = item.margin;
          item.element.style.zIndex = item.zIndex;
        });
        logInfo("Ursprüngliche Stile wiederhergestellt");
        
        // Show overlay again
        overlay.style.display = 'block';

        const { jsPDF } = window.jspdf;
        const img = new Image();
        img.src = dataUrl;

        logInfo("Starte PDF-Generierung mit jsPDF");
        await new Promise((resolve) => {
          img.onload = () => {
            logInfo("Bild für PDF geladen", {
              width: img.width,
              height: img.height
            });
            
            const PDF_INCHES_WIDTH = pdfInchesWidth;
            const PDF_INCHES_HEIGHT = pdfInchesHeight;

            const PDF_POINTS_WIDTH = PDF_INCHES_WIDTH * 72;
            const PDF_POINTS_HEIGHT = PDF_INCHES_HEIGHT * 72;

            logInfo("PDF-Maße", {
              inches: { width: PDF_INCHES_WIDTH, height: PDF_INCHES_HEIGHT },
              points: { width: PDF_POINTS_WIDTH, height: PDF_POINTS_HEIGHT },
              orientation: pdfOrientation
            });

            const pdf = new jsPDF({
              orientation: pdfOrientation,
              unit: 'pt',
              format: [PDF_POINTS_WIDTH, PDF_POINTS_HEIGHT]
            });

            const imgAspectRatio = img.width / img.height;
            const pdfAspectRatio = PDF_POINTS_WIDTH / PDF_POINTS_HEIGHT;

            let finalImgWidth, finalImgHeight;
            if (imgAspectRatio > pdfAspectRatio) {
              finalImgWidth = PDF_POINTS_WIDTH;
              finalImgHeight = PDF_POINTS_WIDTH / imgAspectRatio;
            } else {
              finalImgHeight = PDF_POINTS_HEIGHT;
              finalImgWidth = PDF_POINTS_HEIGHT * imgAspectRatio;
            }

            const xOffset = (PDF_POINTS_WIDTH - finalImgWidth) / 2;
            const yOffset = (PDF_POINTS_HEIGHT - finalImgHeight) / 2;

            logInfo("Finale Bild-Position im PDF", {
              width: finalImgWidth,
              height: finalImgHeight,
              xOffset,
              yOffset
            });
            
            try {
              pdf.addImage(dataUrl, 'PNG', xOffset, yOffset, finalImgWidth, finalImgHeight, undefined, 'FAST');
              logInfo("Bild erfolgreich zum PDF hinzugefügt");
            } catch (error) {
              logInfo("Fehler beim Hinzufügen des Bildes zum PDF", { error: error.message });
              throw error;
            }

            const fileName = `Order_${randomId}.pdf`;
            logInfo("PDF erstellt", { fileName });
            
            try {
              const pdfBlob = pdf.output('blob');
              logInfo("PDF-Blob erstellt", { size: pdfBlob.size });
              sendToServer(pdfBlob, fileName).then(() => resolve());
            } catch (error) {
              logInfo("Fehler beim Erstellen des PDF-Blobs", { error: error.message });
              throw error;
            }
          };
          
          img.onerror = (error) => {
            logInfo("Fehler beim Laden des Bildes für PDF", { error: error.message });
            resolve();
          };
        });

      } catch (error) {
        const errorMessage = error.message || 'Unbekannter Fehler';
        logInfo('Fehler bei der PDF-Generierung', { 
          error: errorMessage,
          stack: error.stack
        });
        console.error('Error generating PDF:', error);
        alert('Bei der Generierung des PDFs ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.');
      } finally {
        logInfo("PDF-Generierung abgeschlossen");
        spinner.remove();
        generatePdfButton.disabled = false;
        generatePdfButton.style.cursor = 'pointer';
        overlay.style.display = 'none';

        const galleryPreview = document.querySelector('.gallery-preview');
        const body = document.body;
        const tabMobileHeader = document.querySelector('.tab_mobile-header');
        const previewSettings = document.querySelector('.preview-settings');
        const previewSettingsOverlay = document.querySelector('.preview-settings_overlay');

        if (galleryPreview) {
          galleryPreview.classList.remove('active');
          if (previewSettingsOverlay) {
            previewSettingsOverlay.classList.remove('visible');
          }
        }

        if (body) body.classList.remove('active');
        if (tabMobileHeader) tabMobileHeader.classList.add('active');
        if (previewSettings) previewSettings.classList.add('p-hidden');

        // Scroll to #mobile_trigger
        const mobileTrigger = document.querySelector('#mobile_trigger');
        if (mobileTrigger) {
          logInfo("Scrolle zu #mobile_trigger");
          mobileTrigger.scrollIntoView({ behavior: 'smooth', block: 'start' });

          // Trigger click event on add-to-cart button
          const addToCartButton = document.querySelector('[data-add-to-cart-text="In den Warenkorb"]');
          if (addToCartButton) {
            logInfo("Klicke 'In den Warenkorb' Button");
            addToCartButton.click();
          } else {
            logInfo("'In den Warenkorb' Button nicht gefunden");
          }
        } else {
          logInfo("#mobile_trigger nicht gefunden");
        }
      }
    } else {
      logInfo("Element #print_pdf nicht gefunden");
      console.error('Element #print_pdf nicht gefunden.');
      alert('Vorschaubereich für PDF nicht gefunden. Bitte laden Sie die Seite neu und versuchen Sie es erneut.');
      
      // Clean up in case of error
      const spinner = generatePdfButton.querySelector('.spinner');
      if (spinner) spinner.remove();
      generatePdfButton.disabled = false;
      generatePdfButton.style.cursor = 'pointer';
      overlay.style.display = 'none';
    }
  }

  if (generatePdfButton) {
    logInfo('PDF-Button gefunden und Event-Listener hinzugefügt');
    
    // Generate PDF button click event - now shows modal first
    generatePdfButton.addEventListener('click', async (event) => {
      logInfo("PDF-Button wurde geklickt - zeige Bestätigungsmodal");
      event.preventDefault();
      event.stopPropagation();
      
      // Show confirmation modal instead of directly generating PDF
      showConfirmationModal();
    });
  } else {
    logInfo('PDF-Button nicht gefunden');
    console.error('Generate PDF button not found.');
  }

  // Accept button click event
  if (acceptModalButton) {
    acceptModalButton.addEventListener('click', async (event) => {
      logInfo("Bestätigung erhalten - starte PDF-Generierung");
      event.preventDefault();
      event.stopPropagation();
      
      // Hide modal
      hideConfirmationModal();
      
      // Start PDF generation
      await generatePdf();
    });
    logInfo('Accept-Button Event-Listener hinzugefügt');
  } else {
    logInfo('Accept-Button nicht gefunden');
    console.error('Accept modal button not found.');
  }

  // Optional: Close modal when clicking outside of it
  if (pdfProcessingModal) {
    pdfProcessingModal.addEventListener('click', (event) => {
      if (event.target === pdfProcessingModal) {
        logInfo("Modal durch Außenklick geschlossen");
        hideConfirmationModal();
      }
    });
  }

  function generateRandomId(length = 8) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from({ length }, () => characters.charAt(Math.floor(Math.random() * characters.length))).join('');
  }

  async function sendToServer(pdfBlob, fileName) {
    logInfo("Starte Upload zum Server", { fileName });
    
    const formData = new FormData();
    await formData.append('pdfFile', pdfBlob, fileName);
    formData.append('clientInfo', JSON.stringify({
      userAgent: navigator.userAgent,
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      timestamp: new Date().toISOString()
    }));

    try {
      const uploadStart = performance.now();
      const response = await fetch('https://baurelia.mainwebsite.ch/uploadpdf/improved-upload-pdf.php', {
        method: 'POST',
        body: formData,
      });
      const uploadEnd = performance.now();
      logInfo(`Server-Upload abgeschlossen in ${(uploadEnd - uploadStart).toFixed(2)}ms`);
      
      if (response && response.ok) {
        const data = await response.json();
        logInfo('Server-Antwort', data);

        if (data && data.file_path) {
          const pdfUrl = `https://baurelia.mainwebsite.ch/uploadpdf${data.file_path}`;
          logInfo('PDF-URL gesetzt', { pdfUrl });
          setPdfInputValue(pdfUrl);
        } else {
          logInfo('PDF-URL nicht in Server-Antwort gefunden', data);
          console.error('PDF URL not found in the server response:', data);
        }
      } else {
        const errorText = await response.text();
        logInfo('Server-Fehler', { 
          status: response ? response.status : 'keine Antwort', 
          statusText: response ? response.statusText : '',
          responseText: errorText
        });
      }
    } catch (error) {
      logInfo('Netzwerkfehler beim Upload', { error: error.message, stack: error.stack });
      console.error('Network error:', error);
      alert('Bei der Übertragung des PDFs ist ein Netzwerkfehler aufgetreten. Bitte versuchen Sie es erneut.');
      return null;
    }
  }

  function setPdfInputValue(pdfUrl) {
    const pdfInput = document.getElementById('pdf_link');
    if (pdfInput) {
      pdfInput.value = pdfUrl;
      logInfo('PDF-Link im Input-Feld gesetzt');
    } else {
      logInfo('PDF Input-Feld nicht gefunden');
      console.error('PDF input field not found');
    }

    if (generatePdfButton) {
      generatePdfButton.disabled = true;
      generatePdfButton.style.backgroundColor = '#cccccc';
      generatePdfButton.style.color = '#ffffff';
      generatePdfButton.style.cursor = 'not-allowed';
      logInfo('PDF-Button deaktiviert nach erfolgreicher Generierung');
    }
  }
});